import RestClient from "../rest.client"

export default class EventService {
    static async getEvents() {
        return await RestClient.call({
            url: '/events',
            method: 'get',
            headers: { 'Authorization': localStorage.getItem('token') }
        })
    }

    static async getNewEvents(lastId: number) {
        console.log(lastId)
        return await RestClient.call({
            url: '/events/new_events',
            method: 'get',
            params: {
                lastId
            },
            headers: { 'Authorization': localStorage.getItem('token') }
        })
    }
} 